import React, {useEffect, useState} from 'react';
//Components
import {ActivityIndicator, Animated, Image, Keyboard, TouchableOpacity, View} from 'react-native'
import {
    CustomButton,
    Dialog,
    FilePicker,
    FileType,
    FlatGrid,
    Header,
    Hr,
    IndicatorViewPager,
    InputField,
    Label,
    Modal,
    PagerTabIndicator
} from "components/src/components";
//Utils
import styles from './styles';

import {
    Color,
    CommonStyle,
    Constants,
    decryptId,
    Icon,
    IS_WEB,
    showMessage,
    Strings,
    ThemeUtils,
    validation
} from "components/src/utils";
import {connect} from "react-redux";
import {useMutation, useQuery} from "@apollo/react-hooks";
import {PROPERTY_SHOW_CASE_DETAILS} from "components/src/api/query";
import {
    DELETE_SHOW_CASE_IMAGE,
    EDIT_PROPERTY_SHOWCASE,
    REPLACE_SHOW_CASE_IMAGE,
    UPLOAD_SHOW_CASE_IMAGE
} from "components/src/api/mutation";
import PhotoDetails from "components/src/components/view/PhotoDetails";

const scrollY = new Animated.Value(0);

function PropertyImageDetails(props) {

    const {history, navigation} = props;

    const showCaseDetailsFromPage = IS_WEB ? history.location?.state?.showcase ?? null : navigation.getParam('showcase', null);
    if (!showCaseDetailsFromPage) {
        IS_WEB ? history.goBack() : navigation.goBack();
    }
    const [service, setService] = useState(showCaseDetailsFromPage ?? {});

    const [heading, setHeadLines] = useState(showCaseDetailsFromPage?.heading ?? "");
    const [errHeadline, setErrHeadLines] = useState(null);

    const [coverImage, setCoverImage] = useState([]);
    const [coverImageUrl, setCoverImageUrl] = useState([]);

    const [selectionEnable, setSelectionEnable] = useState(false);
    const [selectedImages, setSelectedImages] = useState([]);

    const [isPhotoDetailVisible, setPhotoDetailVisible] = useState(false);

    const [deleteVisible, setDeleteVisible] = useState(false)

    const [imageForPreview, setImageForPreview] = useState({})

    const [saveServiceDetails, saveDetailsMutation] = useMutation(EDIT_PROPERTY_SHOWCASE);

    const [replaceImage, replaceImageMutation] = useMutation(REPLACE_SHOW_CASE_IMAGE, {
        refetchQueries: [{
            query: PROPERTY_SHOW_CASE_DETAILS,
            variables: {
                id: showCaseDetailsFromPage?.id ?? (IS_WEB ? decryptId(props.match.params?.propertyId) : null)
            }
        }]
    });

    const [uploadImages, uploadImagesMutation] = useMutation(UPLOAD_SHOW_CASE_IMAGE, {
        refetchQueries: [{
            query: PROPERTY_SHOW_CASE_DETAILS,
            variables: {
                id: showCaseDetailsFromPage?.id ?? (IS_WEB ? decryptId(props.match.params?.propertyId) : null)
            }
        }]
    });

    const [deleteImages, deleteImagesMutation] = useMutation(DELETE_SHOW_CASE_IMAGE, {
        refetchQueries: [{
            query: PROPERTY_SHOW_CASE_DETAILS,
            variables: {
                id: showCaseDetailsFromPage?.id ?? (IS_WEB ? decryptId(props.match.params?.propertyId) : null)
            }
        }]
    });

    const {loading, data, error} = useQuery(PROPERTY_SHOW_CASE_DETAILS, {
        skip: !showCaseDetailsFromPage,
        variables: {
            id: showCaseDetailsFromPage?.id ?? (IS_WEB ? decryptId(props.match.params?.propertyId) : null)
        }
    });

    useEffect(() => {
        setSelectionEnable(!!selectedImages.length)
    }, [selectedImages]);

    useEffect(() => {
        if (coverImage[0]) {
            setCoverImageUrl(IS_WEB ? URL.createObjectURL(coverImage[0]) : coverImage[0]?.uri)
        }
    }, [coverImage])

    useEffect(() => {
        if (data?.property_show_case) {
            setService(data?.property_show_case);
            setHeadLines(data?.property_show_case?.heading);

        }
    }, [data]);

    const validate = () => {
        if (!IS_WEB) {
            Keyboard.dismiss()
        }
        let errHead = validation('headline', heading);


        if (!errHead) {
            let variables = {
                heading: heading,
            };
            if (coverImage?.length) {
                variables.coverImage = coverImage[0]
            }
            if (showCaseDetailsFromPage) {
                variables.id = service.id
            }
            saveServiceDetails({
                variables: variables
            }).then(({data}) => {
                showMessage(data?.edit_property_showcase?.meta?.message, Constants.MessageType.SUCCESS)
                IS_WEB ? history.goBack() : navigation.goBack()
            }).catch(() => {

            })
        } else {
            setErrHeadLines(errHead);

        }
    };


    const addOrRemoveImage = (id) => {
        let updatedImages = selectedImages.slice();
        if (updatedImages.includes(id)) {
            updatedImages.splice(updatedImages.indexOf(id), 1)
        } else {
            updatedImages.push(id)
        }
        setSelectedImages(updatedImages)
    };

    const _renderTabIndicator = () => {
        return <PagerTabIndicator tabs={[
            {
                text: "Bildedetaljer"
            }, {
                text: Strings.imageGallery
            }]}/>;
    };


    const renderPhotoGallery = () => {
        return (
            <>
                <Label small font_medium mt={10} mb={15}>
                    {"Last opp bildegalleri"}
                </Label>

                <FilePicker multiple
                            style={{alignSelf: 'flex-start'}}
                            type={FileType.IMAGE}
                            onFilePicked={(data, files) => {
                                if (files.length) {
                                    uploadImages({
                                        variables: {
                                            id: service?.id,
                                            photos: files,
                                        }
                                    }).catch(() => {

                                    })
                                }
                            }}>
                    <View style={[styles.SubViewIcon, {backgroundColor: Color.GRAY}]}>
                        {uploadImagesMutation.loading ? (
                            <ActivityIndicator color={Color.PRIMARY}/>
                        ) : (<Icon name={'add'}
                                   size={ThemeUtils.responsiveScale(60)}
                                   color={Color.PRIMARY_LIGHT}/>)}

                    </View>
                </FilePicker>
                <Hr lineStyle={{marginTop: 20}}/>
                {selectionEnable ? (
                    <View style={styles.propertySelectionCont}>

                        <Icon name={'tickmark'}
                              size={ThemeUtils.fontNormal}
                              color={Color.PRIMARY}/>
                        <Label small
                               font_medium
                               ml={15}
                               style={CommonStyle.flex}>
                            {`${selectedImages.length} ${Strings.photoselected}`}
                        </Label>
                        <Dialog title={Strings.deletePhoto}
                                visible={deleteVisible}
                                onNegativePress={() => setDeleteVisible(false)}
                                onPositivePress={() => {
                                    deleteImages({
                                        variables: {
                                            ids: selectedImages,
                                            showCaseId: service?.id
                                        }
                                    }).then(({}) => {
                                        setSelectedImages([])
                                    }).catch(() => {

                                    })
                                    setDeleteVisible(false)
                                }}
                                desc={Strings.deleteConfirmation}/>
                        {deleteImagesMutation.loading ? (
                            <ActivityIndicator color={Color.PRIMARY}/>
                        ) : (
                            <TouchableOpacity activeOpacity={0.6}
                                              onPress={() => {
                                                  setDeleteVisible(true)
                                              }}>
                                <Icon name={'delete'}
                                      size={ThemeUtils.fontNormal}
                                      color={Color.RED}/>
                            </TouchableOpacity>)}
                        <TouchableOpacity onPress={() => {
                            setSelectedImages([])
                        }} activeOpacity={0.6} style={{marginLeft: 20}}>
                            <Icon name={'close'}
                                  size={ThemeUtils.fontNormal}/>
                        </TouchableOpacity>
                    </View>
                ) : (<Label small
                            font_medium
                            mt={15}
                            mb={5}>
                    {Strings.Photos}
                </Label>)}
            </>
        );
    };

    const renderImageGrid = (data, isDeletable) => {
        return <View style={styles.ImageGridView}>
            <FlatGrid data={data}
                      spacing={ThemeUtils.COMMON_HORIZONTAL_MARGIN}
                      itemDimension={ThemeUtils.responsiveScale(150)}
                      renderItem={({item}) => {
                          return (
                              <TouchableOpacity
                                  key={item.id}
                                  onLongPress={() => selectionEnable ? null : addOrRemoveImage(item.id)}
                                  onPress={() => {
                                      if (selectionEnable) {
                                          addOrRemoveImage(item.id)
                                      } else {
                                          setImageForPreview(item)
                                          setPhotoDetailVisible(true)
                                      }
                                  }}
                                  activeOpacity={0.7}>

                                  {selectionEnable && selectedImages.includes(item.id) ? (
                                      <View style={[styles.selectedImage]}>
                                          <Icon name={'tickmark'}
                                                size={ThemeUtils.fontNormal}
                                                color={Color.TERNARY_TEXT_COLOR}/>
                                      </View>) : null}

                                  <Image source={{uri: `${Constants.APIConfig.STORAGE_URL}${item?.image}`}}

                                         style={styles.GridImage}/>
                              </TouchableOpacity>
                          )
                      }}/>
        </View>
    };
    return (
        <View style={styles.cont}>
            <Header tintColor={Color.PRIMARY}

                    style={CommonStyle.blankHeader}
                    navigation={IS_WEB ? history : navigation}/>

            <View>
                <View style={styles.contentCont}>
                    <View style={styles.titleCont}>
                        <Label xlarge
                               font_medium
                               mt={5}>
                            {Strings.propertyImageGallery}
                        </Label>
                    </View>
                </View>

            </View>
            <IndicatorViewPager keyboardShouldPersistTaps={'always'}

                                indicator={_renderTabIndicator()}
                                style={{flex: 1, backgroundColor: 'white'}}>
                <View>
                    {loading && !data ? (
                        <ActivityIndicator color={Color.PRIMARY}
                                           style={CommonStyle.loader}/>
                    ) : (
                        <>
                            <Animated.ScrollView scrollEventThrottle={1}
                                                 keyboardShouldPersistTaps={'always'}

                                                 contentContainerStyle={styles.flexGrow}
                                                 onScroll={Animated.event(
                                                     [{nativeEvent: {contentOffset: {y: scrollY}}}],
                                                     {useNativeDriver: true})}>

                                <View style={styles.orderCont}>
                                    <Label font_medium>
                                        {Strings.projectName}
                                    </Label>
                                    <InputField mt={10}
                                                align={'center'}
                                                type={'text'}
                                                error={errHeadline}
                                                onFocus={() => setErrHeadLines(null)}
                                                value={heading}
                                                onChange={setHeadLines}
                                    />
                                    <Label font_medium
                                           mb={10}>
                                        {Strings.coverImage}
                                    </Label>
                                    <FilePicker type={FileType.IMAGE}
                                                onFilePicked={(data, file) => setCoverImage(file)}/>

                                    {coverImage?.length ? (
                                        <Image source={IS_WEB ? coverImageUrl : {uri: coverImageUrl}}
                                               style={styles.img}/>
                                    ) : showCaseDetailsFromPage?.cover_image && !coverImage.length ? (
                                        <Image
                                            source={{uri: `${Constants.APIConfig.STORAGE_URL}${showCaseDetailsFromPage?.cover_image}`}}
                                            style={styles.img}/>
                                    ) : null}
                                </View>

                            </Animated.ScrollView>
                            <View style={styles.bottomButtonContainer}>
                                <CustomButton loading={saveDetailsMutation.loading}

                                              style={{flex: 0.45}}
                                              title={Strings.save}
                                              onPress={validate}/>
                                <CustomButton onPress={() => {
                                    if (!IS_WEB) {
                                        Keyboard.dismiss()
                                    }
                                    IS_WEB ? history.goBack() : navigation.goBack()
                                }}
                                              bgColor={Color.WHITE}
                                              textColor={Color.PRIMARY_TEXT_COLOR}
                                              borderColor={Color.PRIMARY}
                                              borderWidth={1}
                                              style={{flex: 0.45}}
                                              title={Strings.cancel}/>
                            </View>

                        </>
                    )}

                </View>
                <View>
                    <Animated.ScrollView scrollEventThrottle={1}
                                         contentContainerStyle={styles.flexGrow}
                                         onScroll={Animated.event(
                                             [{nativeEvent: {contentOffset: {y: scrollY}}}],
                                             {useNativeDriver: true})}>
                        <View>
                            <View style={styles.orderCont}>
                                <Modal visible={isPhotoDetailVisible}
                                       onRequestClose={() => setPhotoDetailVisible(false)}>
                                    <PhotoDetails onClose={() => setPhotoDetailVisible(false)}
                                                  loading={replaceImageMutation.loading}
                                                  deleteMutation={DELETE_SHOW_CASE_IMAGE}
                                                  onReplaceImage={replaceImage}
                                                  refetchQuery={{
                                                      refetchQueries: [{
                                                          query: PROPERTY_SHOW_CASE_DETAILS,
                                                          variables: {
                                                              id: showCaseDetailsFromPage?.id ?? (IS_WEB ? decryptId(props.match.params?.propertyId) : null)
                                                          }
                                                      }]
                                                  }}
                                                  replaceVariables={{
                                                      id: imageForPreview?.id,
                                                      showCaseId: service?.id
                                                  }}
                                                  variables={{
                                                      ids: [imageForPreview?.id],
                                                      showCaseId: service?.id
                                                  }}
                                                  imageForPreview={imageForPreview}
                                    />
                                </Modal>
                                {renderPhotoGallery()}
                            </View>
                            {renderImageGrid(service?.PropertyShowcaseImages ?? [])}
                        </View>
                    </Animated.ScrollView>
                </View>
            </IndicatorViewPager>

        </View>
    )
}

const mapStateToProps = (state) => {
    return {}
};
export default connect(mapStateToProps)(PropertyImageDetails);
